import React, { useEffect, useState } from "react";
import { ShimmerPostDetails } from "react-shimmer-effects";

import NewFooter from "@/components/common/footer/NewFooter";
import PopupSignInUp from "@/components/common/PopupSignInUp";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import { fetchCmsDataForNodes } from "../../api/cms";
import CAFCHeroSection from "./CAFCHeroSection";
import CAFCTextSection from "./CAFCTextSection";
import CAFCSearchSection from "./CAFCSearchSection";
import OtherLinkFooter from "@/components/common/footer/OtherLinkFooter";



const CAFCLandingPage = () => {

    const [loading, setLoading] = useState(true);
    const [cmsData, setCMSData] = useState([]);
    const [error, setError] = useState(null);


    useEffect(() => {
        const getCMSData = async () => {
            setLoading(true);
            setError(null);
            try {
                fetchCmsDataForNodes("global/CAFCStaticData").then(
                    (response) => {
                        const cmsContent = response?.["global/CAFCStaticData"]?.results?.[0];
                        console.log('cmsContent', cmsContent);
                        setCMSData(cmsContent || []);
                        setError(null);
                    });

            } catch (err) {
                setError("Unable to load content. Please try again later.");
                console.error("Error fetching data: ", err);
            } finally {
                setLoading(false);
            }
        };
        getCMSData();
    }, []);

    const renderContent = () => {
        if (loading) {
            return (
                <div className="loading-section">
                    <ShimmerPostDetails card cta variant="EDITOR" />
                </div>
            );
        }

        console.log('cmsData', cmsData);

        if (error ) {
          return (
            <div className="d-flex align-items-center justify-content-center vh-100">
              <div className="text-center">
                <div className="alert alert-danger" role="alert">
                  <h2 className="alert-heading">Unable to Load Content</h2>
                  <p>
                    {error ||
                      "Sorry, something went wrong while fetching the data. Please try again later."}
                  </p>
                  <hr />
                  <button
                    className="btn btn-thm btn-primary"
                    onClick={() => window.location.reload()}
                  >
                    Retry
                  </button>
                </div>
              </div>
            </div>
          );
        }

        return (
          <>
            <CAFCHeroSection cmsData={cmsData} type="residential" />
            <CAFCTextSection cmsData={cmsData} type="residential" />
            <CAFCSearchSection cmsData={cmsData} type="residential" /> 
          </>
        );
    };
    return (
        <>

            <div className="d-flex flex-column min-vh-100">
                <Header />
                <MobileMenu />
                <PopupSignInUp />

                <div
                    style={{ flex: 1 }}
                    className="flex-grow-1 mt-md-5 pt-md-3"
                >
                    {renderContent()}
                </div>
                 <div className="container-fluid px-0">
                {/* <Footer /> */}
                <OtherLinkFooter/>
                <NewFooter/>
            </div>
                {/* <OtherLinkFooter/>
                <NewFooter/> */}
            </div>
        </>
    );
};

export default CAFCLandingPage;                                         